export default "__VITE_ASSET__DJaXxK8x__"